import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/Assistant/AssistantButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArrowRight","ExternalLink"] */ "/vercel/path0/app/Components/icons.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
